module.exports = __webpack_public_path__ + "img/arrow.2f616dec.svg";